{
  "version": 1,
  "asset_id": "e538abd0-2421-429e-9bec-4b61ea9e8cda",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/e538abd0-2421-429e-9bec-4b61ea9e8cda/hero-primeiro-corte.mp4",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/e538abd0-2421-429e-9bec-4b61ea9e8cda/hero-primeiro-corte.mp4",
  "original_filename": "hero-primeiro-corte.mp4",
  "size": 1357580,
  "content_type": "video/mp4",
  "created_at": "2026-11-03T17:23:21Z"
}
